var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 107,
    viewBox: "0 0 112 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.4668 73.1099C69.0201 89.0099 60.3868 95.5024 41.4868 95.5024H40.8801C20.0201 95.5024 11.6668 87.5966 11.6668 67.8541V39.0574C11.6668 19.3149 20.0201 11.4091 40.8801 11.4091H41.4868C60.2468 11.4091 68.8801 17.8133 70.4201 33.4483",
    stroke: "#EB5757",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0008 53.5L95.1074 53.5",
    stroke: "#EB5757",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7007 68.2959L100.334 53.5001L84.7007 38.7042",
    stroke: "#EB5757",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogoutIcon);
export default __webpack_public_path__ + "static/media/main-logout-icon.f327c49736b54fe9e3403748a0888360.svg";
export { ForwardRef as ReactComponent };